var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organism-sidebar-accordion",class:{ active: _vm.isMobileMenuOpen }},[_c('div',{staticClass:"space-results"},[_c('MoleculesCommonMoleculeSidebarAccordionResults',{attrs:{"pins-info":_vm.pinsInfo,"sidebar-title":_vm.sidebarTitle}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }